import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a5c99395dd08a0014984981_1784578221278_6604fefd/mkubwa/src/app/sports/page.tsx");
